import { Component } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import { SignPhoneNumberAdjustment } from 'src/app/model/sign/phone/sign-phone-number-adjustment';
import { SignPhoneNumberAdjustmentOverview } from 'src/app/model/sign/phone/sign-phone-number-adjustment-overview';
import { SignPhoneNumberAdjustmentControllerRequestService } from 'src/app/services/api/sign-associations/implementations/sign-phone-number-adjustment-controller-request.service';
import { SignPhoneNumberAdjustmentPortalOverviewControllerRequestService } from './sign-phone-number-adjustment-portal-overview-controller-request.service';
import { FilterStoreService } from 'src/app/services/filter-store.service';
import {
  ModalService,
  ObservableHandlerPair
} from 'src/app/services/modal.service';
import { PageIndexService } from 'src/app/services/page-index-service';
import {
  AbstractSignsPortalAssociationOverviewComponent,
  SIGN_ASSOCIATION_TYPE
} from '../abstract-signs-portal-association-overview.component';
import { SignPortalAssociation } from '../sign-portal-association';
import { SignPhoneNumberAdjustmentEditComponent } from '../../../sign-associations/edit-association/phone/sign-phone-number-adjustment-edit.component';

@Component({
  selector: 'sign-phone-number-adjustment-portal-overview',
  templateUrl: '../abstract-signs-portal-association-overview.component.html',
  styleUrls: ['../abstract-signs-portal-association-overview.component.scss']
})
export class SignPhoneNumberAdjustmentPortalOverviewComponent extends AbstractSignsPortalAssociationOverviewComponent<
  SignPhoneNumberAdjustment,
  SignPhoneNumberAdjustmentOverview
> {
  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected signPhoneNumberAdjustmentPortalOverviewControllerRequestService: SignPhoneNumberAdjustmentPortalOverviewControllerRequestService,
    protected signPhoneNumberAdjustmentControllerRequestService: SignPhoneNumberAdjustmentControllerRequestService,
    protected modalService: ModalService,
    protected _lightbox: Lightbox
  ) {
    super(
      filterStoreService,
      pageIndexService,
      signPhoneNumberAdjustmentPortalOverviewControllerRequestService,
      signPhoneNumberAdjustmentControllerRequestService,
      modalService,
      _lightbox,
      SIGN_ASSOCIATION_TYPE.SIGN_PHONE_NUMBER_ADJUSTMENT
    );
  }

  protected getLocalStorageKey(): string {
    return 'SignPhoneNumberAdjustmentPortalOverviewComponent';
  }

  public editItem(item: SignPortalAssociation): void {
    this.modalService.openComponentInModal(
      SignPhoneNumberAdjustmentEditComponent,
      [
        { key: 'signId', value: item.sign.id },
        { key: 'assocObject', value: item }
      ],
      new ObservableHandlerPair(
        modalRef => modalRef.componentInstance.saveSuccessEvent,
        (res: SignPhoneNumberAdjustment) => {
          if (res != null) {
            this.doLoadSubject.next();
          }
        }
      ),
      { width: '750px', maxHeight: '90vh' }
    );
  }
}
